import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64432d08")

_pushScopeId("data-v-64432d08")
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "card p-fluid" }
const _hoisted_3 = { class: "p-field p-grid" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " ID ", -1)
const _hoisted_5 = { class: "p-col-6 p-md-2" }
const _hoisted_6 = { class: "p-field p-grid" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " ユーザー名 ", -1)
const _hoisted_8 = { class: "p-col-6 p-md-2" }
const _hoisted_9 = { class: "p-field p-grid" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " メールアドレス ", -1)
const _hoisted_11 = { class: "p-col-6 p-md-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "p-field p-grid" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " パスワード変更 ", -1)
const _hoisted_15 = { class: "p-col-12 p-md-6 p-mb-2 p-mb-0 p-mb-md-0" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "p-field p-grid" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " パスワード ", -1)
const _hoisted_19 = { class: "p-col-6 p-md-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "p-field p-grid" }, [
  /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }),
  /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-8 p-mb-0 p-mb-md-0" }, [
    /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "※パスワードは半角大文字、 半角小文字、数字、記号を含む8文字以上を設定")
  ])
], -1)
const _hoisted_21 = { class: "p-field p-grid" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " 確認用パスワード ", -1)
const _hoisted_23 = { class: "p-col-6 p-md-4" }
const _hoisted_24 = { class: "p-field p-grid" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " 権限 ", -1)
const _hoisted_26 = {
  id: "kengen",
  class: "p-col-12 p-md-10",
  style: {"display":"flex"}
}
const _hoisted_27 = {
  key: 0,
  class: "p-mr-4"
}
const _hoisted_28 = { class: "p-field p-grid" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " 有効区分 ", -1)
const _hoisted_30 = {
  id: "dispKbn",
  class: "p-col-12 p-md-10",
  style: {"display":"flex"}
}
const _hoisted_31 = { class: "p-mr-4" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", {
  class: "input-label",
  for: 'dispKbn1'
}, " 有効 ", -1)
const _hoisted_33 = { class: "p-mr-4" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", {
  class: "input-label",
  for: 'dispKbn0'
}, " 無効 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_zMessage = _resolveComponent("zMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: 'ユーザ詳細',
    visible: _ctx.mDispDetail,
    "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => (_ctx.mDispDetail = $event)),
    style: [{ width: '80vw'}, {"max-width":"1100px"}],
    modal: true,
    closable: false
  }, {
    footer: _withId(() => [
      (_ctx.mMODEXX == 1 || _ctx.mMODEXX == 2)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "閉じる",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.fncClose())),
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"}
          }))
        : _createCommentVNode("", true),
      (_ctx.mMODEXX == 3)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "中止",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.fncCancel())),
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"}
          }))
        : _createCommentVNode("", true),
      (_ctx.mMODEXX == 1)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 2,
            label: "修正",
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"},
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.fncUpdate()))
          }))
        : _createCommentVNode("", true),
      (_ctx.mMODEXX == 2 || _ctx.mMODEXX == 3)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 3,
            label: "登録",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.fncDBToroku())),
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"}
          }))
        : _createCommentVNode("", true),
      (_ctx.mMODEXX == 1)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 4,
            label: "削除",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.fncDBDelete())),
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"}
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withId(() => [
      _createVNode(_TransitionGroup, {
        name: "z-message",
        tag: "div"
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mMessage, (msg) => {
            return (_openBlock(), _createBlock(_component_zMessage, {
              severity: msg.severity,
              key: msg.id
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(msg.content), 1)
              ]),
              _: 2
            }, 1032, ["severity"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_InputText, {
                id: "userid",
                type: "tel",
                modelValue: _ctx.mShosaiData.USERID,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mShosaiData.USERID = $event)),
                maxlength: "20",
                onInput: _ctx.fncInputHankaku,
                style: {"width":"200px"},
                readonly: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3,
                class: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3 ? 'read-only' : ''
              }, null, 8, ["modelValue", "onInput", "readonly", "class"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_InputText, {
                id: "usernm",
                type: "text",
                modelValue: _ctx.mShosaiData.USERNM,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.mShosaiData.USERNM = $event)),
                maxlength: "50",
                style: {"width":"200px"},
                readonly: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3,
                class: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3 ? 'read-only' : ''
              }, null, 8, ["modelValue", "readonly", "class"])
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_InputText, {
                id: "mailad",
                type: "email",
                modelValue: _ctx.mShosaiData.MAILAD,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.mShosaiData.MAILAD = $event)),
                maxlength: "50",
                onInput: _ctx.fncInputHankaku,
                style: {"width":"200px"},
                readonly: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3,
                class: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3 ? 'read-only' : ''
              }, null, 8, ["modelValue", "onInput", "readonly", "class"])
            ])
          ]),
          (_ctx.mMODEXX == 3)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, [
                    _createVNode(_component_Checkbox, {
                      binary: true,
                      modelValue: _ctx.mPassCng,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.mPassCng = $event)),
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fncPassChange()))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.mMODEXX == 2 || _ctx.mPassCng == true)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, [
                    _createVNode(_component_InputText, {
                      id: "passwd",
                      type: "text",
                      pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!\"#$%&'\\(\\)*+-.,\\/\\\\:;<=>?@\\[\\]^_`\\{\\|\\}~])[a-zA-Z0-9!\"#$%&'\\(\\)*+-.,\\/\\\\:;<=>?@\\[\\]^_`\\{\\|\\}~]{8,}$",
                      modelValue: _ctx.mPasswd,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.mPasswd = $event)),
                      maxlength: "64",
                      onInput: _ctx.fncInputHankaku,
                      style: {"width":"100%"},
                      readonly: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3,
                      class: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3 ? 'read-only' : ''
                    }, null, 8, ["modelValue", "onInput", "readonly", "class"])
                  ]),
                  _createVNode(_component_Button, {
                    id: "setpass",
                    label: "パスワード生成",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fncGetPass())),
                    class: "btnPass",
                    style: {"width":"150px"}
                  })
                ]),
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_InputText, {
                      id: "passwd2",
                      type: "text",
                      modelValue: _ctx.mPasswd2,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.mPasswd2 = $event)),
                      maxlength: "64",
                      onInput: _ctx.fncInputHankaku,
                      style: {"width":"100%"},
                      readonly: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3,
                      class: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3 ? 'read-only' : ''
                    }, null, 8, ["modelValue", "onInput", "readonly", "class"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode("div", _hoisted_26, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mKengenList, (row) => {
                return (_openBlock(), _createBlock(_Fragment, {
                  key: row.HAYOCD
                }, [
                  (row.HAYOCD == 22 || ((_ctx.mMODEXX == 1 || _ctx.mMODEXX == 3) && row.HAYOCD != 1))
                    ? (_openBlock(), _createBlock("div", _hoisted_27, [
                        _createVNode(_component_RadioButton, {
                          class: "p-mr-2",
                          id: 'kengen' + row.HAYOCD,
                          value: row.HAYOCD,
                          modelValue: _ctx.mShosaiData.KENGEN,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.mShosaiData.KENGEN = $event)),
                          disabled: _ctx.mMODEXX == 1 || _ctx.mMODEXX == 3
                        }, null, 8, ["id", "value", "modelValue", "disabled"]),
                        _createVNode("label", {
                          class: "input-label",
                          for: 'kengen' + row.HAYOCD
                        }, _toDisplayString(row.HAYON2), 9, ["for"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _createVNode(_component_RadioButton, {
                  id: "dispKbn1",
                  class: "p-mr-2",
                  value: 1,
                  modelValue: _ctx.mShosaiData.YUKOKB,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.mShosaiData.YUKOKB = $event)),
                  disabled: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3 || _ctx.mShosaiData.KENGEN === 21
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_32
              ]),
              _createVNode("div", _hoisted_33, [
                _createVNode(_component_RadioButton, {
                  id: "dispKbn0",
                  class: "p-mr-2",
                  value: 0,
                  modelValue: _ctx.mShosaiData.YUKOKB,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.mShosaiData.YUKOKB = $event)),
                  disabled: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3 || _ctx.mShosaiData.KENGEN === 21
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_34
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
})